import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {Col, Row} from "react-bootstrap";
import PWAInstallPrompt from '../components/PWAInstallPrompt';

const Char = () => {
    const [characters, setCharacters] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const [error, setError] = useState('');

    const fullUrl = (path) => {
        if (!path) return null;
        return path.startsWith('http') ? path : `https://fantasyworldtrpg.cz${path}`;
    };

    useEffect(() => {
        const fetchChars = async () => {
            try {
                const res = await fetch('https://api.fantasyworldtrpg.cz/echo/chars.php', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ fw_user: localStorage.getItem('fw_user') || null }),
                });

                const data = await res.json();
                if (data.status === 'success') {
                    setCharacters(data.chars || []);
                } else {
                    setCharacters([]);
                    setError(data.message)
                }


            } catch (err) {
                console.error('Chyba při načítání postav:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchChars();
    }, []);

    const selectChar = async (data) => {
        try {
            await fetch("https://api.fantasyworldtrpg.cz/echo/register_echo_user.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: data.id })
            });
        } catch (err) {
            console.error("Chyba při registraci do echo_users:", err);
        }

        localStorage.setItem('echo_user', data.id);
        localStorage.setItem('echo_user_account_type', data.account_type);
        localStorage.setItem('echo_user_data', JSON.stringify(data));
        window.location.href = '/';
    };


    if (loading) return <p className="text-center mt-5">Načítání postav...</p>;

    return (
        <div className="container my-5 py-5">
            <h2 className="mb-4 text-center">Vyber si postavu</h2>
            <Row className="d-flex flex-wrap justify-content-center gap-3">
                {error && <div className="alert alert-danger">{error}</div>}
                {characters.map((char) => (
                    <Col key={char.id} md={5} sm={12}>
                        <button
                            key={char.id}
                            className="btn btn-outline-danger w-100"
                            onClick={() => selectChar(char)}
                        >
                            <img style={{height: "30px", width: "30px", objectFit: "cover", objectPosition: "center"}} className="rounded-circle" src={fullUrl(char.img)}/>
                            <b className="ms-2">{char.selectname}</b> {char.name !== char.selectname && `(${char.name})`}
                            {(Number(char.chat) > 0 || Number(char.notif) > 0) && (
                                <span className="badge bg-warning border-2 border-dark text-dark ms-2">
                                    {Number(char.chat) + Number(char.notif)}
                                </span>
                            )}
                        </button>
                    </Col>
                ))}
            </Row>
            {/*<div className="my-3">
                <span style={{cursor: "pointer"}} onClick={() => navigate("/updates")}>Co je nového na echo?</span>
            </div>*/}
            <div>
                <PWAInstallPrompt/>
            </div>
            <div className="mt-5">
                <span className="mt-5 lead" style={{cursor: "pointer"}}
                      onClick={() => navigate("/rules")}><i className="bi bi-file-earmark-ruled-fill"></i> Pravidla sítě</span>
            </div>
        </div>
    );
};

export default Char;
